import React from "react";

export default function MaintenancePolicy({ name }) {
  return (
    <div>
      <h4 style={{ textAlign: "center" }}>
        Owner Operator Maintenance Policy Agreement
      </h4>
      <p>
        I {name ? <b>{name}</b> : ""} being an Owner Operator for Shah Transport
        Freight Lines agree that I will adhere to the Maintenance Policy of Shah
        Transport Freight Lines. I will as well turn into Shah Transport Freight
        Lines all maintenance reports and receipts associated with my truck and
        preventative maintenance performed and repairs completed.
      </p>
      <p>Failure to turn in reports will result in discipline. </p>
      <p>
        All Maintenance reports and receipts must be turned in to the Safety
        Department no later than the 15th of each month for the previous month.
        E.g. January reports must be turned in by February 15th.{" "}
      </p>
    </div>
  );
}
